import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { SwiperComponent } from 'swiper/angular';
import { NgOtpInputConfig, NgOtpInputComponent } from 'ng-otp-input';
import { ToastrService } from 'ngx-toastr';
import Swiper, { SwiperOptions } from 'swiper';

import { UserService } from '@app/services';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  templateUrl: './modal-set-nip.component.html',
  styleUrls: ['./modal-set-nip.component.scss']
})
export class ModalSetNipComponent {
  @ViewChild('nipInput', { static: false }) nipInput: NgOtpInputComponent;
  @ViewChild('confirmNipInput', { static: false }) confirmNipInput: NgOtpInputComponent;
  @ViewChild('swiper', { static: false }) swiper?: SwiperComponent;

  slideConfig: SwiperOptions = {
    pagination: { clickable: true },
    speed: 300,
    autoHeight: true,
  };

  otpInputConfig: NgOtpInputConfig = {
    length: 4,
    disableAutoFocus: false,
    isPasswordInput: true,
  };

  confOtpInputConfig: NgOtpInputConfig = {
    length: 4,
    disableAutoFocus: false,
    isPasswordInput: true,
  };

  nip: string;
  confirmNip: string;

  activeIndex: 0 | 1 | 2 = 0;
  onCheck = false;

  constructor(private toastr: ToastrService, private userServ: UserService, private modal: MatDialogRef<ModalSetNipComponent, boolean>) { }

  onSlideChange(event: [Swiper]) {
    this.activeIndex = event[0].activeIndex as 0 | 1 | 2;
  }

  slideTo(index: number) {
    this.swiper.swiperRef.slideTo(index);
    if (index === 1) {
      setTimeout(() => {
        const f: any = document.getElementsByClassName('otp-input');
        f[0].focus();
      }, 500);
    }
  }

  checkNip(nip: string) {
    if (nip.length === this.confOtpInputConfig.length) {
      this.nip = nip;

      setTimeout(() => {
        this.slideTo(2);

        setTimeout(() => {
          const f: any = document.getElementsByClassName('otp-input');
          f[4].focus();
        }, 500);
      }, 200);
    }
  }

  checkConfirmNip(nip: string) {
    if (!this.onCheck) {
      this.onCheck = true;

      if (nip.length === this.otpInputConfig.length) {
        this.confirmNip = nip;

        if (this.nip === this.confirmNip) {
          this.userServ.setNIP(this.nip).subscribe({
            next: r => {
              this.toastr.success('Se ha agregado tu MoNIP exitosamente.');
              this.modal.close(true);
            },
            complete: () => this.onCheck = false
          });
        } else {
          this.nipInput.setValue('');
          this.confirmNipInput.setValue('');
          this.confirmNip = '';
          this.nip = '';
          this.toastr.warning('No coincide MoNIP. Favor de volver a escribirlo.');
          setTimeout(() => {
            this.slideTo(1);
            this.onCheck = false;
            const f: any = document.getElementsByClassName('otp-input');
            f[0].focus();
          }, 200);
        }
      } else {
        this.onCheck = false;
      }
    }
  }

}
